import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import CustomTextArea from "components/CustomTextArea";
import AllPeerMessages from "components/PeerRecognition/AllPeerMessages/AllPeerMessages";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import ColorSelection from "components/ColorSelection";
import TeamMemberSelection from "components/TeamMemberSelection";
import ButtonWithProgress from "components/ButtonWithProgress";
import { ReactComponent as AttachIcon } from "assets/img/icons/add-media-icon.svg";
import ChatGptAssistModal from "components/ChatGptAssistModal";

const TextAreaSection = ({
  selectedColor,
  setSelectedColor,
  showMessages,
  toggleTitleBar,
  formik,
  selectTitle,
  selectedTitleId,
  postColors,
  onAttachmentSelected,
  setValue,
  team,
  addToast,
  selectedMember,
  setSelectedMember,
  uploadProgress,
}) => {
  const [acceptedList, setAcceptedList] = useState([
    ".png",
    ".jpg",
    ".jpeg",
    ".mp4",
    ".mp3",
    ".webm",
  ]);
  useEffect(() => {
    setSelectedColor(postColors[0]);

    //eslint-disable-next-line
  }, [postColors]);
  useEffect(() => {
    if (formik.values.intro_id || formik.values.outro_id) {
      setAcceptedList([".mp4"]);
      return;
    }
    setAcceptedList([".png", ".jpg", ".jpeg", ".mp4", ".mp3", ".webm"]);
  }, [formik.values.intro_id, formik.values.outro_id]);
  useEffect(() => {
    if (
      formik.values.postattachment &&
      !formik.values.postattachment?.type.includes("video") &&
      (formik.values.intro_id || formik.values.outro_id)
    ) {
      formik.setFieldValue(["postattachment"], null);
      addToast(
        "Please Select Intro or Outro Video with Attached/Recorded Video",
        { appearance: "error" }
      );
    }
    //eslint-disable-next-line
  }, [formik.values.postattachment]);
  return (
    <React.Fragment>
      <div className="main-text">
        <div className="text-header">
          <p className="fw-bold title">Create new Recognition</p>
        </div>
        <div className="col-12">
          <div className="text-area overflow-hidden mb-1">
            <div className="messages">
              <FontAwesomeIcon
                style={{ color: selectedColor?.textColor }}
                className={classNames({
                  // white:
                  //   showMessages && selectedTitleId === 1 ? true : false,
                  // black:
                  //   showMessages && selectedTitleId !== 1 ? true : false,
                  black: showMessages ? true : false,
                })}
                icon={faBars}
                onClick={() => toggleTitleBar(!showMessages)}
              />
            </div>
            <div className="peer-recognition-text-field">
              <ChatGptAssistModal setValue={setValue} />
              <CustomTextArea
                textAreaClass={classNames({
                  "text-area-design": true,
                  areaDefaultWidth: !showMessages ? true : false,
                  areaLessWidth: showMessages ? true : false,
                })}
                parentStyle={{ marginBottom: "unset" }}
                errorClass="peerRecognitionSecondError"
                background={selectedColor?.gradientString}
                textColor={selectedColor?.textColor}
                formik={formik}
                placeholder={"Thoughts, Inspiration and Actions"}
                fieldName={"text"}
                rows={3}
              />
            </div>
            <div
              onClick={() => toggleTitleBar(!showMessages)}
              className={classNames({
                messageContainer: true,
                messageOpen: showMessages,
              })}
            >
              <AllPeerMessages
                selectTitle={selectTitle}
                selectedTitleId={selectedTitleId}
              />
            </div>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-center">
          <div className="d-flex select-color">
            <div className="label">
              <p>Select background color</p>
            </div>
            <div className="celebrationColor">
              <ColorSelection
                selectedColor={selectedColor}
                colors={postColors}
                setSelectedColor={setSelectedColor}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between peerFooter">
          <div className="add-media d-flex align-items-center">
            <span className="text greenish text-decoration-underline fw-bold">
              <AttachmentSelection
                labelAttachment="labelVideoAttachment"
                AttachIcon={AttachIcon}
                accepted={acceptedList}
                attachmentIconStyle={{
                  marginRight: "3px",
                  cursor: "pointer",
                  fill: "#A1A2A9",
                }}
                attachmentClass="fa-2x peerAddMedia"
                attachmentTextClass="pointer text-decoration-underline text greenish fw-bold"
                showRecorderIcon={false}
                attachmentText={
                  formik.values.intro_id || formik.values.outro_id
                    ? "Add Video"
                    : "Add Media"
                }
                onChange={onAttachmentSelected}
              />
            </span>
          </div>
          <div className="tag-members d-flex align-items-center">
            <span className="logo greenish">
              <FontAwesomeIcon
                icon={faUserPlus}
                className="fa-2x peerMemberSelection"
              />
            </span>
            <span className="text greenish text-decoration-underline mx-1 fw-bold">
              <div
                style={{
                  paddingLeft: selectedMember.length > 0 ? "5px" : "unset",
                }}
              >
                <TeamMemberSelection
                  team_id={team.id}
                  selectMemberText="Tag Members"
                  taskSelectMemberStyle={{
                    color: "A8CF45",
                    fontWeight: "bold",
                  }}
                  selectedMember={selectedMember}
                  clearMembers={() => setSelectedMember([])}
                  onMemberSelect={(member) => {
                    setSelectedMember([...selectedMember, member]);
                    addToast("Member is selected ", {
                      appearance: "success",
                    });
                  }}
                  discardMember={(member) => {
                    setSelectedMember(
                      selectedMember.filter((selectedMember) => {
                        return selectedMember.id !== member.id;
                      })
                    );
                    addToast("Member is removed ", {
                      appearance: "error",
                    });
                  }}
                  setSelectedMember={setSelectedMember}
                />
              </div>
            </span>
          </div>
          <div className="on-web">
            <ButtonWithProgress
              initialText={"Create"}
              progress={uploadProgress}
              // onClick={formik.handleSubmit}
              buttonWithProgressClass="create-button"
              isSubmitting={formik.isSubmitting}
            />
          </div>
        </div>
        <div className="tag-members-list"></div>
      </div>
    </React.Fragment>
  );
};

export default TextAreaSection;
